<template>
  <div class="menu" v-if="visible">
    <img class="logo" src="../assets/images/m/m_logo.png" alt="" />
    <div class="nav">
      <ul>
        <li v-for="(item, index) in navList" :key="index">
          <a :class="{ 'nav-active': index === active_index }" @click="next(index)">{{ item }}</a>
        </li>
      </ul>
    </div>
    <div id="googleplay-m">
      <img @click="goLink('google')" src="../assets/images/google_play_1.png" alt="" />
    </div>
    <div id="onestore-m">
      <img @click="goLink('store')" src="../assets/images/one_store_1.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    visible: Boolean,
    index: Number
  },
  data() {
    return {
      active_index: 0,
      navList: ['메인', '이벤트', '직업', '이미지'],
      link_list: {
        google: 'https://googleplay-kr.onelink.me/IpYd/website',
        store: 'https://onesto.re/0000764012'
      }
    }
  },
  watch: {
    index(value) {
      // console.log('value', value)
      // if (value >= 4) {
      //   this.active_index = value - 1
      // } else {
      //   this.active_index = value
      // }
      this.active_index = value
    }
  },
  methods: {
    /**跳转链接 */
    goLink(key) {
      window.open(this.link_list[key], '_blank')
    },
    /**页面切换 */
    next(index) {
      console.log('index', index)
      // 向下滚动一页
      // if (index > 3) {
      //   this.active_index = index + 1
      // } else {
      //   this.active_index = index
      // }
      this.active_index = index

      this.$emit('close', this.active_index)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/theme.less';
.bg-base {
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.menu {
  position: relative;
  position: fixed;
  top: 2.0833rem;
  right: 0;
  width: 6.25rem;
  height: 9.4444rem;
  background-color: @menu-bg;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 0.3472rem;
  box-sizing: border-box;
  .logo {
    width: 2.0833rem;
    height: 0.8333rem;
    margin: 0.5556rem 0;
  }
  ul {
    li {
      margin-bottom: 0.2778rem;
      text-align: right;
      a {
        font-size: 0.4861rem;
        color: @font-nav;
        font-family: NanumSquareRoundOTFB;
      }
      .nav-active {
        color: @font-active;
      }
    }
  }
  #googleplay-m,
  #onestore-m {
    margin-top: 0.2778rem;
    cursor: pointer;
    img {
      width: 4.0278rem;
      height: 1.2083rem;
    }
  }
}
</style>
